import request from '@/utils/request';

// 获取自由兑品牌
export function getZydBrands(data) {
  return request({
    url: '/orders/card-rule-extend/cake-store-zyd-brands',
    method: 'post',
    data: data
  });
}

// 获取业务类型
export function getBusinessType(data) {
  return request({
    url: '/orders/order-config/business-type',
    method: 'post',
    data: data
  });
}
// 获取卡类型
export function getCardType(data) {
  return request({
    url: '/orders/order-config/card-type',
    method: 'post',
    data: data,
    hideLoading: true
  });
}
// 获取卡类型
export function getSearchCardType(data) {
  return request({
    url: '/orders/order-config/card-type-search',
    method: 'post',
    data: data,
    hideLoading: true
  });
}
// 获取卡类型
export function getAddOrderCardType(data) {
  return request({
    url: '/orders/order-config/add-order-card-type',
    method: 'post',
    data: data,
    hideLoading: true
  });
}
// 获取所有卡类型
export function getAllCardType(data) {
  return request({
    url: '/orders/order-config/all-card-type',
    method: 'post',
    data: data,
    hideLoading: true
  });
}
// 添加订单
export function addOrder(data) {
  return request({
    url: '/orders/order/add',
    method: 'post',
    timeout: 3 * 60 * 1000,
    data: data
  });
}
// 编辑订单
export function editOrder(data) {
  return request({
    url: '/orders/order/up',
    method: 'post',
    data: data
  });
}
// 获取订单列表
export function getOrderList(data) {
  return request({
    url: '/orders/order/list',
    method: 'post',
    data: data,
    timeout: 3 * 60 * 1000
  });
}
// 获取模块订单列表
export function getMenuOrderList(data) {
  return request({
    url: '/orders/menu-order/list',
    method: 'post',
    data: data,
    timeout: 3 * 60 * 1000
  });
}
// 获取模块应用菜单下 装修相关列表
export function getMenuDecorList(url, data) {
  return request({
    url: url,
    method: 'post',
    data: data
  });
}
// 获取订单列表
export function getCustomerOrderList(data) {
  return request({
    url: '/orders/order/customer-order',
    method: 'post',
    data: data,
    timeout: 3 * 60 * 1000
  });
}
// 订单审核
export function orderAudit(data) {
  return request({
    url: '/orders/order/audit',
    method: 'post',
    data: data,
    timeout: 3 * 60 * 1000
  });
}
// 订单详情
export function getOrderInfo(data) {
  return request({
    url: '/orders/order/info',
    method: 'post',
    data: data
  });
}
// 礼包售卡信息
export function getGiftExchangeInfo(data) {
  return request({
    url: '/orders/order/exchange-info',
    method: 'post',
    data: data
  });
}
// 添加售卡
export function addCardSale(data) {
  return request({
    url: '/orders/order/add-card-sale',
    method: 'post',
    data: data,
    timeout: 3 * 60 * 1000
  });
}
// 获取退卡售卡列表
export function getOrderCardList(data) {
  return request({
    url: '/orders/order/card-list',
    method: 'post',
    data: data
  });
}
// 获取订单日志
export function getOrderLog(data) {
  return request({
    url: '/orders/order/logs',
    method: 'post',
    data: data
  });
}
// 获取方案日志
export function getPackageLog(data, reportType) {
  var prefix = reportType === 'order' ? '/orders/order-report' : '/orders/package-report';
  return request({
    url: "".concat(prefix, "/logs"),
    method: 'post',
    data: data
  });
}
// 获取卡类型列表
export function getCardTypeList(params) {
  return request({
    url: '/orders/card-bin/index',
    method: 'get',
    params: params
  });
}
// 获取方案下下单信息
export function getGiftOrderInfo(data) {
  return request({
    url: '/orders/order/gift-order-info',
    method: 'post',
    data: data
  });
}
// 获取功能菜单
export function getFunctionMenu(params) {
  return request({
    url: '/orders/new-card-rule/menus',
    method: 'get',
    params: params
  });
}
// 获取组合功能子菜单
export function getChildFunctionMenu(params) {
  return request({
    url: '/orders/new-card-rule/children-menus',
    method: 'get',
    params: params
  });
}
// 获取功能菜单
export function getAllFunctionMenu(params) {
  return request({
    url: '/orders/new-card-rule/all-menus',
    method: 'get',
    params: params,
    hideLoading: true
  });
}
// 获取不支持的供应商
export function getNotSupplier(params) {
  return request({
    url: '/orders/new-card-rule/not-suppliers',
    method: 'get',
    params: params
  });
}
// 获取不支持的品牌
export function getNotBrand(params) {
  return request({
    url: '/orders/new-card-rule/not-brands',
    method: 'get',
    params: params
  });
}
// 获取特殊品牌
export function getSpecialBrand(params) {
  return request({
    url: '/orders/new-card-rule/special-brands',
    method: 'get',
    params: params
  });
}

// 获取特殊品牌
export function getScopeIndex(params) {
  return request({
    url: '/orders/new-card-rule/index',
    method: 'get',
    params: params
  });
}
// 获取标准卡类型规则
export function getStandardIndex(params) {
  return request({
    url: '/orders/new-card-rule/plat-index',
    method: 'get',
    params: params
  });
}
// 保存通用规则
export function saveCardRule(data) {
  return request({
    url: '/orders/new-card-rule/update-default-rule',
    method: 'post',
    data: data
  });
}
// 保存标准卡类型规则
export function saveStandardCardRule(data) {
  return request({
    url: '/orders/new-card-rule/update-plat-default-rule',
    method: 'post',
    data: data
  });
}
// 获取订单规则
export function getOrderRule(data, entryType) {
  var url = {
    platformQueryManage: '/plat/order/order-rule',
    serviceCenter: '/orders/order/order-rule',
    platformConfigOrder: '/plat/order/rule'
  }[entryType];
  return request({
    url: url ? url : '/orders/order/rule',
    method: 'post',
    timeout: 3 * 60 * 1000,
    data: data
  });
}
// 获取订单规则
export function setOrderRule(data) {
  return request({
    url: '/orders/order/set-rule',
    method: 'post',
    data: data
  });
}

// 获取特殊品牌  业绩提成
export function getSpecialBrandList(params) {
  return request({
    url: '/orders/card-bin/brands',
    method: 'get',
    params: params
  });
}
// 添加虚拟卡卷
export function orderSaleAddCard(data) {
  return request({
    url: '/orders/cardsale/add-card',
    method: 'post',
    data: data,
    timeout: 3 * 60 * 1000
  });
}
// 添加虚拟不定额卡卷
export function orderSaleAddUnfixedCard(data) {
  return request({
    url: '/orders/cardsale/add-unfixed-card',
    method: 'post',
    data: data,
    timeout: 3 * 60 * 1000
  });
}
// 虚拟发放退卡退卡审核等信息
export function orderSaleBasInfo(data, entryType) {
  var url = {
    recharge: '/orders/cardsale/base-info',
    orderManage: '/orders/cardsale/base-info',
    platformConfig: '/plat/cardsale/base-info',
    sellCardOrderList: '/orders/voucher-card-sale/base-info'
  }[entryType];
  return request({
    url: entryType ? url : '/orders/cardsale/base-info',
    method: 'post',
    data: data
  });
}
// 虚拟 退卡售卡详情
export function orderSaleInfo(data) {
  return request({
    url: '/orders/cardsale/info',
    method: 'post',
    data: data
  });
}
// 虚拟退卡
export function orderSaleRefund(data) {
  return request({
    url: '/orders/cardsale/refund',
    method: 'post',
    data: data
  });
}
// 售卡退卡详情
export function getOrderSaleDataList(data, entryType) {
  var url = {
    orderManage: '/orders/cardsale/user-list',
    platformConfig: '/plat/cardsale/user-list',
    sellCardOrderList: '/orders/voucher-card-sale/user-list'
  }[entryType];
  return request({
    url: entryType ? url : '/orders/cardsale/user-list',
    method: 'post',
    data: data
  });
}
// 售卡驳回与发放
export function orderSaleDataAudit(data) {
  return request({
    url: '/orders/cardsale/audit',
    method: 'post',
    data: data
  });
}
// 退卡审核与驳回
export function orderRefundDataAudit(data) {
  return request({
    url: '/orders/cardsale/refund-audit',
    method: 'post',
    timeout: 3 * 60 * 1000,
    data: data
  });
}
// 实体卡卷列表
export function getCardSaleList(data, entryType) {
  return request({
    url: entryType == 'sellCardOrderList' ? '/orders/voucher-card-sale/card-list' : '/orders/cardsale/card-list',
    method: 'post',
    data: data
  });
}
// 实体卡卷管理进入列表
export function getCardManageSaleList(data, entryType) {
  var url = {
    orderManage: '/orders/cardsale/manage-card-list',
    platformConfig: '/plat/cardsale/manage-card-list',
    sellCardOrderList: '/orders/voucher-card-sale/manage-card-list'
  }[entryType];
  return request({
    url: entryType ? url : '/orders/cardsale/manage-card-list',
    method: 'post',
    data: data
  });
}
// 实体卡卷列表
export function getCardSaleMobile(data) {
  return request({
    url: '/orders/cardsale/get-shop-mobile',
    method: 'post',
    data: data
  });
}

// 导出订单列表excel
export function exportExcel(data) {
  return request({
    url: '/orders/order/card-info-export',
    method: 'post',
    timeout: 3 * 60 * 1000,
    data: data
  });
}
// 退卡导出订单列表excel
export function exportRefundExcel(data) {
  return request({
    url: '/orders/cardsale/refund-export',
    method: 'post',
    timeout: 3 * 60 * 1000,
    data: data
  });
}
// 获取短信模板提醒
export function getSmsTemplate(params) {
  return request({
    url: '/orders/send-sms/card-sale-template-list',
    method: 'get',
    params: params
  });
}
// 虚拟卡售卡详情发送短信
export function sendMessageRemind(params) {
  return request({
    url: '/orders/order/send-notice',
    method: 'get',
    params: params
  });
}
// 短信提醒
export function sendFictitiousMessageRemind(params) {
  return request({
    url: '/orders/cardsale/send-notice',
    method: 'get',
    params: params
  });
}

// 获取卡类型菜单
export function getCardTypeMenus(params) {
  return request({
    url: '/orders/card-bin/card-bin-menus',
    method: 'get',
    params: params
  });
}
// 添加回款计划
export function addRepaymentPlan(data) {
  return request({
    url: '/orders/paylog/add',
    method: 'post',
    data: data
  });
}
// 回款计划列表
export function repaymentPlanList(data) {
  return request({
    url: '/orders/paylog/list',
    method: 'post',
    data: data
  });
}
// 回款计划作废
export function repaymentPlanDel(data) {
  return request({
    url: '/orders/paylog/del',
    method: 'post',
    data: data
  });
}
// 编辑回款计划
export function repaymentPlanEdit(data) {
  return request({
    url: '/orders/paylog/up',
    method: 'post',
    data: data
  });
}
// 虚拟用户下载模板
export function ordersTemplateDownload(data) {
  return request({
    url: '/orders/template/download',
    method: 'post',
    data: data
  });
}
// 上传虚拟用户
export function ordersTemplateUpload(data) {
  return request({
    url: '/orders/cardsale/upload',
    method: 'post',
    data: data
  });
}
// 传文件退卡，清余额
export function refundOrdersTemplateUpload(data) {
  return request({
    url: '/orders/cardsale/upload-refund-file',
    method: 'post',
    data: data
  });
}
// 保存清余额接口
export function saveClearPoint(data) {
  return request({
    url: '/orders/cardsale/clear-point',
    method: 'post',
    data: data
  });
}
// 计算售总点数总金额
export function getCardCount(data) {
  return request({
    url: '/orders/cardsale/real-card-count-info',
    method: 'post',
    data: data
  });
}
// 申请激活
export function orderApplyAudit(data) {
  return request({
    url: '/orders/cardsale/apply-audit',
    method: 'post',
    data: data
  });
}
// 修改售卡有效期
export function editValidityData(data) {
  return request({
    url: '/orders/cardsale/up-validity-date',
    method: 'post',
    data: data
  });
}
// 礼包配送信息数据
export function getPackageList(data) {
  return request({
    url: '/orders/cardsale/delivery-list',
    method: 'post',
    data: data
  });
}
// 上传礼包配送信息
export function uploadPackageFile(data) {
  return request({
    url: '/orders/cardsale/offline-up-file',
    method: 'post',
    timeout: 3 * 60 * 1000,
    data: data
  });
}
// 校验礼包配送导入信息是否重复
export function checkRepeatPackageInfo(data) {
  return request({
    url: '/orders/cardsale/check-repeat',
    method: 'post',
    timeout: 3 * 60 * 1000,
    data: data
  });
}
// 保存礼包配送上传信息
export function savePackageInfo(data) {
  return request({
    url: '/orders/cardsale/offline-import',
    method: 'post',
    timeout: 3 * 60 * 1000,
    data: data
  });
}
// 配送信息导入日志
export function getOfflineCheckImportLog(params) {
  return request({
    url: '/orders/cardsale/offline-check-import-log',
    method: 'get',
    params: params
  });
}
// 导出礼包配送信息
export function exportPackInfo(data) {
  return request({
    url: '/orders/cardsale/offline-export',
    method: 'post',
    timeout: 3 * 60 * 1000,
    data: data
  });
}
// 获取礼包最大退卡数量
export function getRefundCardNumber(data) {
  return request({
    url: '/orders/cardsale/get-refund-card-number',
    method: 'post',
    data: data
  });
}
// 修改订单金额
export function editMoneyData(data) {
  return request({
    url: '/orders/order/up-money',
    method: 'post',
    data: data
  });
}
// 礼包配送 批量下单
export function AddOrderGift(data) {
  return request({
    url: '/orders/order/shop-add-order',
    method: 'post',
    data: data
  });
}
// 礼包配送 批量作废
export function AbandonOrderGift(data) {
  return request({
    url: '/orders/order/shop-abandon',
    method: 'post',
    data: data
  });
}
// 订单详情回款记录列表
export function getOrderFinancelist(data) {
  return request({
    url: '/orders/order/finance-list',
    method: 'post',
    data: data
  });
}

// 订单取消确认
export function orderCancelConfirm(data) {
  return request({
    url: '/orders/order/cancel-confim',
    method: 'post',
    data: data
  });
}

// 售卡作废
export function cardVoid(data) {
  return request({
    url: '/orders/cardsale/cancel',
    method: 'post',
    data: data
  });
}

// 申请备货
export function aplayStock(data) {
  return request({
    url: '/orders/order/apply-stock-up',
    method: 'post',
    data: data
  });
}

// 备货
export function stockFinish(data) {
  return request({
    url: '/orders/order/stock-up',
    method: 'post',
    data: data
  });
}

// 开始备货
export function startStockUp(data) {
  return request({
    url: '/orders/order/start-stock-up',
    method: 'post',
    data: data
  });
}

// 订单详情添加备注
export function addRemark(data) {
  return request({
    url: '/orders/order/add-remark',
    method: 'post',
    data: data
  });
}

// 编辑售卡详情备注
export function editNote(data) {
  return request({
    url: '/orders/cardsale/up-note',
    method: 'post',
    data: data
  });
}

// 电子码售卡详情导出
export function exportEctronicExcel(data) {
  return request({
    url: '/orders/cardsale/ectronic-export',
    method: 'post',
    timeout: 3 * 60 * 1000,
    data: data
  });
}

// 电子码售卡详情文件密码
export function getExcelPwd(data) {
  return request({
    url: '/orders/cardsale/get-passwd',
    method: 'post',
    data: data
  });
}

// 外采核检
export function checkProcurement(data) {
  return request({
    url: '/orders/order/check-procurement',
    method: 'post',
    data: data
  });
}

// 外采核检
export function exportStockGoods(data) {
  return request({
    url: '/orders/stock-up/export',
    method: 'post',
    data: data
  });
}
// 礼包配送批量取消一键取消
export function cancelOrderGift(data) {
  return request({
    url: '/orders/offline-buy/cancel-order',
    method: 'post',
    data: data
  });
}
// 同步商机
export function getSyncOpportunity(params) {
  return request({
    url: '/orders/opportunity/sync-opportunity',
    method: 'get',
    timeout: 3 * 60 * 1000,
    params: params
  });
}
// 搭售优惠券的时候获取搭售详情
export function getCouponCardInfo(data) {
  return request({
    url: '/orders/coupon/info',
    method: 'post',
    data: data
  });
}
// 创建搭售
export function createCoupon(data) {
  return request({
    url: '/orders/coupon/add-card',
    method: 'post',
    data: data,
    timeout: 3 * 60 * 1000
  });
}
// 优惠券解绑
export function unbindCouponCard(data) {
  return request({
    url: '/orders/coupon/unbind',
    method: 'post',
    data: data
  });
}
// 获取特殊品牌  业绩提成
export function checkEntityMenu(params) {
  return request({
    url: '/orders/order/check-entity-menu',
    method: 'get',
    params: params
  });
}
// 白名单城市树
export function getCityTree(data) {
  var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'movie';
  var url = {
    cake: '/orders/card-rule-extend/cake-city-tree',
    movie: '/orders/card-rule-extend/city-tree',
    orderManage: '/orders/card-rule-extend/order-online-order-city-tree',
    manageCenter: '/orders/card-rule-extend/online-order-city-tree',
    platformConfig: '/orders/card-rule-extend/plat-online-order-city-tree',
    channelManage: '/orders/card-rule-extend/channel-online-order-city-tree',
    orderManageMT: '/orders/card-rule-extend/order-mt-order-city-tree',
    manageCenterMT: '/orders/card-rule-extend/mt-order-city-tree',
    platformConfigMT: '/orders/card-rule-extend/plat-mt-order-city-tree',
    channelManageMT: '/orders/card-rule-extend/channel-mt-order-city-tree',
    orderManageMTWM: '/orders/card-rule-extend/order-mt-waimai-order-city-tree',
    manageCenterMTWM: '/orders/card-rule-extend/mt-waimai-order-city-tree',
    platformConfigMTWM: '/orders/card-rule-extend/plat-mt-waimai-order-city-tree',
    channelManageMTWM: '/orders/card-rule-extend/channel-mt-waimai-order-city-tree',
    orderManageDDMC: '/orders/card-rule-extend/order-ding-d-order-city-tree',
    manageCenterDDMC: '/orders/card-rule-extend/ding-d-order-city-tree',
    platformConfigDDMC: '/orders/card-rule-extend/plat-ding-d-order-city-tree',
    channelManageDDMC: '/orders/card-rule-extend/channel-ding-d-order-city-tree',
    orderManageYH: '/orders/card-rule-extend/order-yong-h-order-city-tree',
    manageCenterYH: '/orders/card-rule-extend/yong-h-order-city-tree',
    platformConfigYH: '/orders/card-rule-extend/plat-yong-h-order-city-tree',
    channelManageYH: '/orders/card-rule-extend/channel-yong-h-order-city-tree',
    orderManageSAM: '/orders/card-rule-extend/order-sam-order-city-tree',
    manageCenterSAM: '/orders/card-rule-extend/sam-order-city-tree',
    platformConfigSAM: '/orders/card-rule-extend/plat-sam-order-city-tree',
    channelManageSAM: '/orders/card-rule-extend/channel-sam-order-city-tree',
    orderManageXXCS: '/orders/card-rule-extend/order-xxcs-order-city-tree',
    manageCenterXXCS: '/orders/card-rule-extend/xxcs-order-city-tree',
    platformConfigXXCS: '/orders/card-rule-extend/plat-xxcs-order-city-tree',
    channelManageXXCS: '/orders/card-rule-extend/channel-xxcs-order-city-tree'
  }[type];
  return request({
    url: url,
    method: 'post',
    data: data
  });
}
// 选中白名单城市列表
export function getCheckedCityList(data) {
  var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'movie';
  var url = {
    cake: '/orders/card-rule-extend/cake-citys',
    movie: '/orders/card-rule-extend/move-citys',
    orderManage: '/orders/card-rule-extend/order-online-order-citys',
    manageCenter: '/orders/card-rule-extend/online-order-citys',
    platformConfig: '/orders/card-rule-extend/plat-online-order-citys',
    channelManage: '/orders/card-rule-extend/channel-online-order-citys',
    orderManageMT: '/orders/card-rule-extend/order-mt-order-citys',
    manageCenterMT: '/orders/card-rule-extend/mt-order-citys',
    platformConfigMT: '/orders/card-rule-extend/plat-mt-order-citys',
    channelManageMT: '/orders/card-rule-extend/channel-mt-order-citys',
    orderManageMTWM: '/orders/card-rule-extend/order-mt-waimai-order-citys',
    manageCenterMTWM: '/orders/card-rule-extend/mt-waimai-order-citys',
    platformConfigMTWM: '/orders/card-rule-extend/plat-mt-waimai-order-citys',
    channelManageMTWM: '/orders/card-rule-extend/channel-mt-waimai-order-citys',
    orderManageDDMC: '/orders/card-rule-extend/order-ding-d-order-citys',
    manageCenterDDMC: '/orders/card-rule-extend/ding-d-order-citys',
    platformConfigDDMC: '/orders/card-rule-extend/plat-ding-d-order-citys',
    channelManageDDMC: '/orders/card-rule-extend/channel-ding-d-order-citys',
    orderManageYH: '/orders/card-rule-extend/order-yong-h-order-citys',
    manageCenterYH: '/orders/card-rule-extend/yong-h-order-citys',
    platformConfigYH: '/orders/card-rule-extend/plat-yong-h-order-citys',
    channelManageYH: '/orders/card-rule-extend/channel-yong-h-order-citys',
    orderManageSAM: '/orders/card-rule-extend/order-sam-order-citys',
    manageCenterSAM: '/orders/card-rule-extend/sam-order-citys',
    platformConfigSAM: '/orders/card-rule-extend/plat-sam-order-citys',
    channelManageSAM: '/orders/card-rule-extend/channel-sam-order-citys',
    orderManageXXCS: '/orders/card-rule-extend/order-xxcs-order-citys',
    manageCenterXXCS: '/orders/card-rule-extend/xxcs-order-citys',
    platformConfigXXCS: '/orders/card-rule-extend/plat-xxcs-order-citys',
    channelManageXXCS: '/orders/card-rule-extend/channel-xxcs-order-citys'
  }[type];
  return request({
    url: url,
    method: 'post',
    data: data
  });
}
// 白名单城市树
export function setWhiteCity(data) {
  var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'movie';
  var url = {
    cake: '/orders/card-rule-extend/cake-set-city',
    movie: '/orders/card-rule-extend/set-city',
    orderManage: '/orders/card-rule-extend/order-online-order-set-city',
    manageCenter: '/orders/card-rule-extend/online-order-set-city',
    platformConfig: '/orders/card-rule-extend/plat-online-order-set-city',
    channelManage: '/orders/card-rule-extend/channel-online-order-set-city',
    orderManageMT: '/orders/card-rule-extend/order-mt-order-set-city',
    manageCenterMT: '/orders/card-rule-extend/mt-order-set-city',
    platformConfigMT: '/orders/card-rule-extend/plat-mt-order-set-city',
    channelManageMT: '/orders/card-rule-extend/channel-mt-order-set-city',
    orderManageMTWM: '/orders/card-rule-extend/order-mt-waimai-order-set-city',
    manageCenterMTWM: '/orders/card-rule-extend/mt-waimai-order-set-city',
    platformConfigMTWM: '/orders/card-rule-extend/plat-mt-waimai-order-set-city',
    channelManageMTWM: '/orders/card-rule-extend/channel-mt-waimai-order-set-city',
    orderManageDDMC: '/orders/card-rule-extend/order-ding-d-order-set-city',
    manageCenterDDMC: '/orders/card-rule-extend/ding-d-order-set-city',
    platformConfigDDMC: '/orders/card-rule-extend/plat-ding-d-order-set-city',
    channelManageDDMC: '/orders/card-rule-extend/channel-ding-d-order-set-city',
    orderManageYH: '/orders/card-rule-extend/order-yong-h-order-set-city',
    manageCenterYH: '/orders/card-rule-extend/yong-h-order-set-city',
    platformConfigYH: '/orders/card-rule-extend/plat-yong-h-order-set-city',
    channelManageYH: '/orders/card-rule-extend/channel-yong-h-order-set-city',
    orderManageSAM: '/orders/card-rule-extend/order-sam-order-set-city',
    manageCenterSAM: '/orders/card-rule-extend/sam-order-set-city',
    platformConfigSAM: '/orders/card-rule-extend/plat-sam-order-set-city',
    channelManageSAM: '/orders/card-rule-extend/channel-sam-order-set-city',
    orderManageXXCS: '/orders/card-rule-extend/order-xxcs-order-set-city',
    manageCenterXXCS: '/orders/card-rule-extend/xxcs-order-set-city',
    platformConfigXXCS: '/orders/card-rule-extend/plat-xxcs-order-set-city',
    channelManageXXCS: '/orders/card-rule-extend/channel-xxcs-order-set-city'
  }[type];
  return request({
    url: url,
    method: 'post',
    data: data
  });
}
// 白名单影院列表
export function getCinemaList(data) {
  return request({
    url: '/orders/card-rule-extend/cinema-list',
    method: 'post',
    data: data
  });
}

// 设置蛋糕到店折扣率
export function setCakeStoreDiscount(data) {
  return request({
    url: '/orders/card-rule-extend/set-cake-store-discount',
    method: 'post',
    data: data
  });
}
// 设置蛋糕自由兑折扣率
export function setCakeStoreZydDiscount(data) {
  return request({
    url: '/orders/card-rule-extend/set-cake-store-zyd-discount',
    method: 'post',
    data: data
  });
}
// 删除影院
export function delCinema(data) {
  return request({
    url: '/orders/card-rule-extend/del-cinema',
    method: 'post',
    data: data
  });
}

// 删除影院
export function addWhiteCinema(data) {
  return request({
    url: '/orders/card-rule-extend/add-cinema',
    method: 'post',
    data: data
  });
}
// 删除影院
export function upCinemaFile(data) {
  return request({
    url: '/orders/card-rule-extend/up-cinema-file',
    method: 'post',
    data: data,
    timeout: 3 * 60 * 1000
  });
}
// 删除影院
export function confirmUpCinemaFile(data) {
  return request({
    url: '/orders/card-rule-extend/import-cinema',
    method: 'post',
    data: data
  });
}
// 退卡校验
export function checkRefundCard(data) {
  return request({
    url: '/orders/cardsale/check-refund-card-risk',
    method: 'post',
    data: data
  });
}
// 退卡校验
export function auditRefundCard(data) {
  return request({
    url: '/orders/cardsale/check-audit-risk',
    method: 'post',
    data: data
  });
}
// 删除影院
export function getNotTags(params) {
  return request({
    url: '/orders/new-card-rule/not-tags',
    method: 'get',
    params: params
  });
}

// 订单 品牌黑名单
export function cakeBrandList(data) {
  return request({
    url: '/orders/card-rule-extend/cake-store-brands',
    method: 'post',
    timeout: 3 * 60 * 1000,
    data: data
  });
}

/**
 * 蛋糕到店类型 & 自由兑功能菜单  设置黑名单 & 利润率 (新)
 * @param {*} params
 * @returns
 */
export function cakeStoreBrands(params, module, menuType) {
  var url = '';
  url = {
    cake_store: '/orders/card-rule-extend/cake-store-brands-v2',
    cake_store_zyd: '/orders/card-rule-extend/cake-store-zyd-brands-v2'
  }[module];
  if (menuType === 'customerSet') {
    url = {
      cake_store_zyd: '/orders/card-rule-extend/cake-store-zyd-brands-customer'
    }[module];
  }
  return request({
    url: url,
    method: 'get',
    timeout: 3 * 60 * 1000,
    params: params
  });
}
/**
 * 蛋糕到店-可用门店列表 (新)
 * @param {*} params
 * @returns
 */
export function cakeStoreStoresV2(params) {
  return request({
    url: '/orders/card-rule-extend/cake-store-stores-v2',
    method: 'get',
    params: params
  });
}

/**
 * 蛋糕到店-可用商品列表 (新)
 * @param {*} params
 * @returns
 */
export function cakeStoreGoodsV2(params) {
  return request({
    url: '/orders/card-rule-extend/cake-store-goods-v2',
    method: 'get',
    params: params
  });
}

/**
 * 蛋糕到店-可用门店导出 (新)
 * @param {*} params
 * @param {*} module 菜单类型 orderDetails | channelCardTypeManage | saleCardTypeManage
 * @returns
 */
export function exportCakeStoreStoresV2(params, module) {
  var url = '/orders/card-rule-extend/cake-store-stores-v2-export';
  if (module === 'channelCardTypeManage') {
    url = '/orders/card-rule-extend/cake-store-stores-v2-common-export';
  } else if (module === 'saleCardTypeManage') {
    url = '/orders/card-rule-extend/cake-store-stores-v2-sale-export';
  }
  return request({
    url: url,
    method: 'get',
    params: params
  });
}

/**
 * 蛋糕到店-可用商品导出 (新)
 * @param {*} params
 * @param {*} module 菜单类型 orderDetails | channelCardTypeManage | saleCardTypeManage
 * @returns
 */
export function exportCakeStoreGoodsV2(params, module) {
  var url = '/orders/card-rule-extend/cake-store-goods-v2-export';
  if (module === 'channelCardTypeManage') {
    url = '/orders/card-rule-extend/cake-store-goods-v2-common-export';
  } else if (module === 'saleCardTypeManage') {
    url = '/orders/card-rule-extend/cake-store-goods-v2-sale-export';
  }
  return request({
    url: url,
    method: 'get',
    params: params
  });
}

/**
 * 蛋糕类型获取品牌数据（新	）
 * @param {*} params
 * @param {*} module
 * @param {*} menuType
 * @returns
 */
export function cakeBrands(params, menuType) {
  var url = '/orders/card-rule-extend/cake-todoor-brands-v2';
  return request({
    url: url,
    method: 'get',
    timeout: 3 * 60 * 1000,
    params: params
  });
}
/**
 * 蛋糕到家可用商品
 * @param {*} params
 * @returns
 */
export function getCakeTodoorGoods(params) {
  return request({
    url: '/orders/card-rule-extend/cake-todoor-goods-v2',
    method: 'get',
    timeout: 3 * 60 * 1000,
    params: params
  });
}
/**
 * 蛋糕到家可用sku
 * @param {*} params
 * @returns
 */
export function getCakeTodoorSkus(params) {
  return request({
    url: '/orders/card-rule-extend/cake-todoor-skus-v2',
    method: 'get',
    timeout: 3 * 60 * 1000,
    params: params
  });
}
/**
 * 在线点单类型获取品牌数据（新	）
 * @param {*} params
 * @returns
 */
export function onlineFoodBrands(params) {
  var url = '/orders/card-rule-extend/online-foods-v2';
  return request({
    url: url,
    method: 'get',
    timeout: 3 * 60 * 1000,
    params: params
  });
}
/**
 * 电影类型获取品牌数据（新	）
 * @param {*} params
 * @param {*} module
 * @param {*} menuType
 * @returns
 */
export function movieBrands(params, menuType) {
  var url = '/orders/card-rule-extend/cinemas-v2';
  return request({
    url: url,
    method: 'get',
    timeout: 3 * 60 * 1000,
    params: params
  });
}
/**
 * 景区门票类型 获取可用景区数据（新）
 * @param {*} params
 * @returns
 */
export function ticketBrands(params) {
  return request({
    url: '/orders/card-rule-extend/scenicspots-v2',
    method: 'get',
    timeout: 3 * 60 * 1000,
    params: params
  });
}
export function exportCakeStoreData(params, module) {
  var url = '/orders/card-rule-extend/cake-store-brands-v2-export';
  if (module === 'channelCardTypeManage') {
    url = '/orders/card-rule-extend/cake-store-brands-v2-common-export';
  } else if (module === 'saleCardTypeManage') {
    url = '/orders/card-rule-extend/cake-store-brands-v2-sale-export';
  }
  return request({
    url: url,
    method: 'get',
    params: params
  });
}
export function exportCakeData(params, module) {
  var url = '/orders/card-rule-extend/cake-todoor-brands-v2-export';
  if (module === 'channelCardTypeManage') {
    url = '/orders/card-rule-extend/cake-todoor-brands-v2-common-export';
  } else if (module === 'saleCardTypeManage') {
    url = '/orders/card-rule-extend/cake-todoor-brands-v2-sale-export';
  }
  return request({
    url: url,
    method: 'get',
    params: params
  });
}

/**
 * 导出蛋糕到家可用商品
 * @param {Object} params - 请求参数
 * @param {String} module - 菜单类型 (channelCardTypeManage / saleCardTypeManage)
 */
export function exportCakeGoodsData(params, module) {
  var url = '/orders/card-rule-extend/cake-todoor-goods-v2-export';
  if (module === 'channelCardTypeManage') {
    url = '/orders/card-rule-extend/cake-todoor-goods-v2-common-export';
  } else if (module === 'saleCardTypeManage') {
    url = '/orders/card-rule-extend/cake-todoor-goods-v2-sale-export';
  }
  return request({
    url: url,
    method: 'get',
    params: params
  });
}

/**
 * 导出蛋糕到家可用SKU
 * @param {Object} params - 请求参数
 * @param {String} module - 菜单类型 (channelCardTypeManage / saleCardTypeManage)
 */
export function exportCakeSkuData(params, module) {
  var url = '/orders/card-rule-extend/cake-todoor-skus-v2-export';
  if (module === 'channelCardTypeManage') {
    url = '/orders/card-rule-extend/cake-todoor-skus-v2-common-export';
  } else if (module === 'saleCardTypeManage') {
    url = '/orders/card-rule-extend/cake-todoor-skus-v2-sale-export';
  }
  return request({
    url: url,
    method: 'get',
    params: params
  });
}
export function exportOnlineOrderData(params, module) {
  var url = '/orders/card-rule-extend/online-foods-v2-export';
  if (module === 'channelCardTypeManage') {
    url = '/orders/card-rule-extend/online-foods-v2-common-export';
  } else if (module === 'saleCardTypeManage') {
    url = '/orders/card-rule-extend/online-foods-v2-sale-export';
  }
  return request({
    url: url,
    method: 'get',
    params: params
  });
}
export function exportCakeStoreZYDData(params, module) {
  var url = '/orders/card-rule-extend/cake-store-zyd-brands-v2-export';
  if (module === 'channelCardTypeManage') {
    url = '/orders/card-rule-extend/cake-store-zyd-brands-v2-common-export';
  } else if (module === 'saleCardTypeManage') {
    url = '/orders/card-rule-extend/cake-store-zyd-brands-v2-sale-export';
  }
  return request({
    url: url,
    method: 'get',
    params: params
  });
}
export function exportMovieData(params, module) {
  var url = '/orders/card-rule-extend/cinemas-v2-export';
  if (module === 'channelCardTypeManage') {
    url = '/orders/card-rule-extend/cinemas-v2-common-export';
  } else if (module === 'saleCardTypeManage') {
    url = '/orders/card-rule-extend/cinemas-v2-sale-export';
  }
  return request({
    url: url,
    method: 'get',
    params: params
  });
}
export function exportTicketData(params, module) {
  var url = '/orders/card-rule-extend/scenicspots-v2-export';
  if (module === 'channelCardTypeManage') {
    url = '/orders/card-rule-extend/scenicspots-v2-common-export';
  } else if (module === 'saleCardTypeManage') {
    url = '/orders/card-rule-extend/scenicspots-v2-sale-export';
  }
  return request({
    url: url,
    method: 'get',
    params: params
  });
}
/**
 * 蛋糕到店类型功能菜单 设置黑名单 & 利润率 (新) - 获取品牌分类筛选项
 * @param {*} params
 * @returns
 */
export function getCakeStoreCategory(params) {
  return request({
    url: '/orders/card-rule-extend/cake-store-categorys',
    method: 'get',
    params: params
  });
}
/**
 * 蛋糕自由兑同步客户级黑白名单数据
 * @param {*} data
 * @returns
 */
export function cakeStoreSyncCustomerList(data) {
  return request({
    url: '/orders/card-rule-extend/cake-store-zyd-brands-v2-sync',
    method: 'post',
    data: data
  });
}
/**
 * 蛋糕类型功能菜单 设置黑名单 & 利润率 (新) - 获取品牌分类筛选项
 * @param {*} params
 * @returns
 */
export function getCakeCategory(params) {
  return request({
    url: '/orders/card-rule-extend/cake-todoor-categorys',
    method: 'get',
    params: params
  });
}
// 在线点单 品牌列表
export function onlineOrderBrandList(data, entryType) {
  var url = {
    orderManage: '/orders/card-rule-extend/order-online-order-brands',
    manageCenter: '/orders/card-rule-extend/online-order-brands',
    platformConfig: '/orders/card-rule-extend/plat-online-order-brands',
    channelManage: '/orders/card-rule-extend/channel-online-order-brands',
    platformQueryManage: '/orders/card-rule-extend/order-online-order-brands',
    serviceCenter: '/orders/card-rule-extend/order-online-order-brands'
  }[entryType];
  return request({
    url: url,
    method: 'post',
    data: data
  });
}
// 通用规则 品牌黑名单
export function cakeCommonBrandList(data) {
  return request({
    url: '/orders/card-rule-extend/cake-store-common-brands',
    method: 'post',
    timeout: 3 * 60 * 1000,
    data: data
  });
}
// 获取蛋糕到家数据
export function getCakeHomeBrands(params) {
  return request({
    url: '/orders/card-rule-extend/cake-home-brands',
    method: 'get',
    params: params
  });
}
// 保存蛋糕到家品牌黑名单
export function setCakeHomeBrands(data) {
  return request({
    url: '/orders/card-rule-extend/set-extend',
    method: 'post',
    data: data
  });
}
// 订单规则自由兑品牌黑名单
export function setBlackCake(data) {
  return request({
    url: '/orders/card-rule-extend/set-extend',
    method: 'post',
    data: data
  });
}
// 通用规则自由兑品牌黑名单
export function setCommonBlackCake(data) {
  return request({
    url: '/orders/card-rule-extend/set-common-extend',
    method: 'post',
    data: data
  });
}
// 特殊金额
export function getSpecialOrderList(data) {
  return request({
    url: '/orders/special-order/list',
    method: 'post',
    data: data
  });
}
// 修改订单详情提成，比例
export function editProportio(data) {
  return request({
    url: '/orders/order/up-proportion',
    method: 'post',
    data: data
  });
}
// 特殊金额处理
export function specialOrderProcessed(data) {
  return request({
    url: '/orders/special-order/processed',
    method: 'post',
    data: data
  });
}
// 虚拟卡详情关闭电子签名
export function signClose(data) {
  return request({
    url: '/orders/cardsale/sign-close',
    method: 'post',
    data: data
  });
}
// 关闭刮刮卡
export function scrapeCardClose(data) {
  return request({
    url: '/orders/cardsale/scraping-close',
    method: 'post',
    data: data
  });
}
// 检查订单可售点数是否充足
export function checkAddCard(data) {
  return request({
    url: '/orders/cardsale/check-add-card-sale',
    method: 'post',
    data: data
  });
}
// 线下集采获取礼包信息
export function getOfflinePackageInfo(data) {
  return request({
    url: '/orders/offline-buy/package',
    method: 'post',
    data: data
  });
}
// 线下集采提交售卡
export function saveOfflinePackageCard(data) {
  return request({
    url: '/orders/offline-buy/add-card-sale',
    method: 'post',
    data: data
  });
}
// 线下集采备货列表修改配送信息
export function updateOfflineStockUP(data) {
  return request({
    url: '/orders/stock-up/up-send-stock-type',
    method: 'post',
    data: data
  });
}
// 线下集采申请备货
export function applyOfflinePackage(data) {
  return request({
    url: '/orders/offline-buy/apply-stock-up',
    method: 'post',
    data: data
  });
}
// 作废备货
export function toVoidStockUp(data) {
  return request({
    url: '/orders/offline-buy/voided-stock-up',
    method: 'post',
    data: data
  });
}
// 上传充值文件
export function upRechargeFile(data) {
  return request({
    url: '/orders/order-recharge/up-recharge-file',
    method: 'post',
    data: data
  });
}
// 上传充值文件
export function upUnfixedRechargeFile(data) {
  return request({
    url: '/orders/order-recharge/up-unfixed-recharge-file',
    method: 'post',
    data: data
  });
}
// 上传扣费文件文件
export function upDeductFile(data) {
  return request({
    url: '/orders/order-recharge/up-deduct-file',
    method: 'post',
    data: data
  });
}
// 保存充值
export function addRecharge(data) {
  return request({
    url: '/orders/order-recharge/add-recharge',
    method: 'post',
    data: data
  });
}
// 保存扣费
export function addDeduct(data) {
  return request({
    url: '/orders/order-recharge/add-deduct',
    method: 'post',
    data: data
  });
}
// 充值扣款列表
export function getRechargeList(data) {
  return request({
    url: '/orders/order-recharge/recharger-list',
    method: 'post',
    data: data
  });
}
// 充值审核
export function auditRecharge(data) {
  return request({
    url: '/orders/order-recharge/audit',
    method: 'post',
    data: data
  });
}
// 扣费审核
export function auditDeduct(data) {
  return request({
    url: '/orders/order-recharge/deduct-audit',
    method: 'post',
    data: data
  });
}
// 获取签名信息
export function getSignInfo(data) {
  return request({
    url: '/orders/cardsale/get-service-recharge-sign-config',
    method: 'post',
    data: data
  });
}
// 设置签名信息
export function setSignInfo(data) {
  return request({
    url: '/orders/cardsale/set-service-recharge-sign-config',
    method: 'post',
    data: data
  });
}
// 订单线下发货校验
/*
POST-data-interface = {
  ids:[],
  order_id: string, //'',
  checks:[{
    mobile:"",
    name:"",
    address:"",
    gift_name:"",
    buy_number:""
  }]
}
*/
export function orderReviewDelivery(data) {
  return request({
    url: '/orders/cardsale/review-delivery',
    method: 'post',
    data: data
  });
}

// 售卡有效期规则列表
export function getOrderRuleList(data) {
  return request({
    url: '/orders/order-rule/list',
    method: 'post',
    data: data
  });
}
// 售卡有效期规则列表
export function getAgentOrderRuleList(data) {
  return request({
    url: '/orders/agent-order-rule/list',
    method: 'post',
    data: data
  });
}
// 获取发货单列表
export function getDeliverOrderList(data) {
  return request({
    url: '/orders/deliver-order/list',
    method: 'post',
    data: data,
    timeout: 3 * 60 * 1000
  });
}
// 获取项目列表发货单列表
export function getVoucherDeliverOrderList(data) {
  return request({
    url: '/orders/voucher-order/deliver-list',
    method: 'post',
    data: data,
    timeout: 3 * 60 * 1000
  });
}
// 添加有效期延期
export function addOrderRule(data) {
  return request({
    url: '/orders/order-rule/add',
    method: 'post',
    data: data
  });
}
// 添加有效期延期
export function addAgentOrderRule(data) {
  return request({
    url: '/orders/agent-order-rule/add',
    method: 'post',
    data: data
  });
}
// 发货单获取城市
export function getDeliverOrderCity(data) {
  return request({
    url: '/orders/deliver-order/city',
    method: 'post',
    data: data
  });
}
// 编辑有效期延期
export function updateOrderRule(data) {
  return request({
    url: '/orders/order-rule/up',
    method: 'post',
    data: data
  });
}
// 编辑有效期延期
export function updateAgentOrderRule(data) {
  return request({
    url: '/orders/agent-order-rule/up',
    method: 'post',
    data: data
  });
}
// 发货单查看手机号
export function getDeliverOrderMobile(data) {
  return request({
    url: '/orders/deliver-order/get-deliver-mobile',
    method: 'post',
    data: data
  });
}
// 删除有效期延期
export function delOrderRule(data) {
  return request({
    url: '/orders/order-rule/del',
    method: 'post',
    data: data
  });
}
// 删除有效期延期
export function delAgentOrderRule(data) {
  return request({
    url: '/orders/agent-order-rule/del',
    method: 'post',
    data: data
  });
}
// 获取仓库
export function getDeliverOrderWareHouse(data) {
  return request({
    url: '/orders/deliver-order/ware-house',
    method: 'post',
    data: data
  });
}
// 发货单导出
export function getDeliverOrderExport(data) {
  return request({
    url: '/orders/deliver-order/export',
    method: 'post',
    data: data,
    timeout: 3 * 60 * 1000
  });
}
// 批量跟进
export function addDeliverOrderFollow(data) {
  return request({
    url: '/orders/deliver-order/add-deliver-follow',
    method: 'post',
    data: data,
    timeout: 3 * 60 * 1000
  });
}
// 刷新
export function addDeliverOrderGetCount(data) {
  return request({
    url: '/orders/deliver-order/get-count-delivery',
    method: 'post',
    data: data,
    timeout: 3 * 60 * 1000
  });
}
// 标准账期列表
export function getOrdersPayList(data) {
  return request({
    url: '/orders/payment-days/list',
    method: 'post',
    data: data,
    timeout: 3 * 60 * 1000
  });
}
// 实际账期超期客户列表
export function getPaymentDaysCustomerList(data) {
  return request({
    url: '/orders/payment-days/customer-list',
    method: 'post',
    data: data,
    timeout: 3 * 60 * 1000
  });
}
// 导出实际账期超期客户
export function exportPaymentDaysCustomerList(data) {
  return request({
    url: '/orders/payment-days/export-customer-list',
    method: 'post',
    data: data,
    timeout: 3 * 60 * 1000
  });
}
// 标准账期列表
export function getAgentOrdersPayList(data) {
  return request({
    url: '/orders/agent-payment-days/list',
    method: 'post',
    data: data,
    timeout: 3 * 60 * 1000
  });
}
// 添加标准账期
export function addOrdersPayItem(data) {
  return request({
    url: '/orders/payment-days/add',
    method: 'post',
    data: data,
    timeout: 3 * 60 * 1000
  });
}
// 添加标准账期
export function addAgentOrdersPayItem(data) {
  return request({
    url: '/orders/agent-payment-days/add',
    method: 'post',
    data: data,
    timeout: 3 * 60 * 1000
  });
}
// 编辑标准账期
export function updateOrdersPayItem(data) {
  return request({
    url: '/orders/payment-days/up',
    method: 'post',
    data: data,
    timeout: 3 * 60 * 1000
  });
}
// 编辑标准账期
export function updateAgentOrdersPayItem(data) {
  return request({
    url: '/orders/agent-payment-days/up',
    method: 'post',
    data: data,
    timeout: 3 * 60 * 1000
  });
}
// 删除标准账期
export function delOrdersPayItem(data) {
  return request({
    url: '/orders/payment-days/del',
    method: 'post',
    data: data,
    timeout: 3 * 60 * 1000
  });
}
// 删除标准账期
export function delAgentOrdersPayItem(data) {
  return request({
    url: '/orders/agent-payment-days/del',
    method: 'post',
    data: data,
    timeout: 3 * 60 * 1000
  });
}
// 超期打折列表
export function getOrdersOverdueList(data) {
  return request({
    url: '/orders/overdue-config/list',
    method: 'post',
    data: data,
    timeout: 3 * 60 * 1000
  });
}
// 超期打折列表
export function getAgentOrdersOverdueList(data) {
  return request({
    url: '/orders/agent-overdue-config/list',
    method: 'post',
    data: data,
    timeout: 3 * 60 * 1000
  });
}
// 添加超期打折
export function addOrdersOverdueItem(data) {
  return request({
    url: '/orders/overdue-config/add',
    method: 'post',
    data: data,
    timeout: 3 * 60 * 1000
  });
}
// 添加超期打折
export function addAgentOrdersOverdueItem(data) {
  return request({
    url: '/orders/agent-overdue-config/add',
    method: 'post',
    data: data,
    timeout: 3 * 60 * 1000
  });
}
// 编辑超期打折
export function updateOrdersOverdueItem(data) {
  return request({
    url: '/orders/overdue-config/up',
    method: 'post',
    data: data,
    timeout: 3 * 60 * 1000
  });
}
// 编辑超期打折
export function updateAgentOrdersOverdueItem(data) {
  return request({
    url: '/orders/agent-overdue-config/up',
    method: 'post',
    data: data,
    timeout: 3 * 60 * 1000
  });
}
// 删除标准账期
export function delOrdersOverdueItem(data) {
  return request({
    url: '/orders/overdue-config/del',
    method: 'post',
    data: data,
    timeout: 3 * 60 * 1000
  });
}
// 删除标准账期
export function delAgentOrdersOverdueItem(data) {
  return request({
    url: '/orders/agent-overdue-config/del',
    method: 'post',
    data: data,
    timeout: 3 * 60 * 1000
  });
}
// 合同签署
export function contractSign(data) {
  return request({
    url: '/orders/contract/sign',
    method: 'post',
    data: data
  });
}
// 合同审核
export function contractAudit(data) {
  return request({
    url: '/orders/contract/audit',
    method: 'post',
    data: data
  });
}
// 修改订单y有效期规则
export function editOrderRuleDate(data) {
  return request({
    url: '/orders/payment-days/up-order-rule',
    method: 'post',
    data: data
  });
}
// 修改订单规则
export function editOrderRuleAccount(data) {
  return request({
    url: '/orders/payment-days/up-payment',
    method: 'post',
    data: data
  });
}
// 修改汇款流水超期打折比例
export function editDelayDiscount(data) {
  return request({
    url: '/orders/payment-days/up-delay-discount',
    method: 'post',
    data: data
  });
}
// 修改汇款流水超期打折比例
export function editCommissionDelayDiscount(data) {
  return request({
    url: '/orders/order-commission/up-delay-discount',
    method: 'post',
    data: data
  });
}
// 获取订单业绩信息
export function getOrderAchievement(data) {
  return request({
    url: '/orders/order/get-order-achievement',
    method: 'post',
    data: data
  });
}
// 获取订单业绩信息
export function editAchievement(data) {
  return request({
    url: '/orders/order/up-achievement',
    method: 'post',
    data: data
  });
}
// 获取订单详情账期异常信息
export function getPaymentStatus(data) {
  return request({
    url: '/orders/payment-days/abnormal-order',
    method: 'post',
    data: data
  });
}
// 获取邮件模板信息
export function getMailInfo(params) {
  return request({
    url: '/mapdepot/mail-template/details',
    method: 'get',
    params: params
  });
}
// 获取邮件模板列表（无分页）
export function getAllMail(params) {
  return request({
    url: '/orders/order/get-mail-template',
    method: 'get',
    params: params
  });
}
// 获取邮件详情
export function getMailDetail(params) {
  return request({
    url: '/mapdepot/mail-template/details',
    method: 'get',
    params: params
  });
}
// 发送邮件模板
export function sendMail(data) {
  return request({
    url: '/orders/order/send-mail-notice',
    method: 'post',
    data: data
  });
}
// 获取企业信息 25.01.15支持搜索
export function getCompanyInfo(params) {
  return request({
    url: '/orders/customer/data',
    method: 'get',
    params: params
  });
}
console.log(process.env.VUE_APP_NAME, 123123);
// 发送邮件模板
export function getQrcodeInfo(data) {
  var url = '';
  if (process.env.VUE_APP_NAME === 'production') {
    url = 'https://packageapi.youlianfuwu.com/preview/home/qrcode';
  } else if (process.env.VUE_APP_NAME === 'test') {
    url = 'https://packageapitest.youlianfuwu.com/preview/home/qrcode';
  } else {
    url = 'https://packageapi.dev.youlianfuwu.com/preview/home/qrcode';
  }
  return request({
    url: url,
    method: 'post',
    data: data
  });
}

// 获取企业信息
export function getOrganizeTree(params) {
  return request({
    url: '/orders/organize/tree',
    method: 'get',
    params: params
  });
}
// 获取企业信息
export function getUserOrganizeTree(params) {
  return request({
    url: '/orders/modal-user/organizes',
    method: 'get',
    params: params
  });
}
// 验证订单搭售规则是否符合
export function checkOrderDiscount(data) {
  return request({
    url: '/orders/order/check-order-discount',
    method: 'post',
    data: data
  });
}
// 验证订单搭售规则是否符合
export function editOrderPerson(data) {
  return request({
    url: '/orders/order/up-userid',
    method: 'post',
    data: data
  });
}
// 获取企业信息
export function getDeliverList(data) {
  return request({
    url: 'orders/deliver-order/get-deliver-list',
    method: 'post',
    data: data
  });
}
// 卡冻结
export function cardFrozen(data) {
  return request({
    url: '/orders/card-operate/frozen',
    method: 'post',
    data: data
  });
}
// 卡解冻
export function cardThaw(data) {
  return request({
    url: '/orders/card-operate/thaw',
    method: 'post',
    data: data
  });
}
// 获取城市列表
export function getOrderCityTree(data) {
  return request({
    url: '/orders/shop-region/get-city-tree',
    method: 'post',
    data: data
  });
}
// 订单详情是否有兑换登记表
export function checkPackagePrice(data) {
  return request({
    url: '/orders/offline-buy/check-package-price',
    method: 'post',
    data: data
  });
}
// 兑换登记表信息
export function getExchangeInfo(data) {
  return request({
    url: '/orders/offline-buy/exchange-info',
    method: 'post',
    data: data
  });
}
// 添加兑换登记表信息
export function addExchange(data) {
  return request({
    url: '/orders/offline-buy/add-exchange',
    method: 'post',
    data: data
  });
}
// 导出兑换登记表信息
export function exportExchange(data) {
  return request({
    url: '/orders/offline-buy/export-exchange',
    method: 'post',
    data: data
  });
}
// 清空兑换登记表信息
export function clearDate(data) {
  return request({
    url: '/orders/offline-buy/del-exchange',
    method: 'post',
    data: data
  });
}
export function exchangeSuspend(data) {
  return request({
    url: '/orders/offline-buy/suspend',
    method: 'post',
    data: data
  });
}
export function resetExchange(data) {
  return request({
    url: '/orders/offline-buy/reset',
    method: 'post',
    data: data
  });
}
export function delExchange(data) {
  return request({
    url: '/orders/offline-buy/del-exchange',
    method: 'post',
    data: data
  });
}

// 获取渠道列表
export function getChannelList(data) {
  return request({
    url: '/orders/channel/list',
    method: 'post',
    data: data
  });
}
// 获取渠道列表
export function getAddOrderChannelList(params) {
  return request({
    url: '/orders/customer/add-order-customer-list',
    method: 'get',
    params: params
  });
}

// 获取图库
export function getStockImg(params) {
  return request({
    url: '/mapdepot/map-depot-type/index-img',
    method: 'get',
    params: params
  });
}
// 修改注册登记表二维码信息
export function setQrcodeConfig(data) {
  return request({
    url: '/orders/offline-buy/set-qrcode-config',
    method: 'post',
    data: data
  });
}
// 获取 参数配置
export function getThemeList(params) {
  return request({
    url: '/mapdepot/map-depot-type/index',
    method: 'get',
    params: params
  });
}

// 图库管理  加载更多图片
export function moreImage(params) {
  return request({
    url: '/mapdepot/map-depot-type/more',
    method: 'get',
    params: params
  });
}

// 添加卡类型
export function cardBinAdd(data) {
  return request({
    url: '/orders/card-bin/add',
    method: 'post',
    data: data
  });
}

// 添加提成
export function addProportion(data) {
  return request({
    url: '/orders/card-bin/add-proportion',
    method: 'post',
    data: data
  });
}

// 获取提成信息
export function getProportion(params) {
  return request({
    url: '/orders/card-bin/get-proportion',
    method: 'get',
    params: params
  });
}

// 更新提成信息
export function updateProportion(params) {
  return request({
    url: '/orders/card-bin/up-proportion',
    method: 'get',
    params: params
  });
}
// 获取卡类型数据
export function getCardTypeData(data) {
  return request({
    url: '/orders/card-bin/get-cardbin',
    method: 'post',
    data: data
  });
}
// 编辑卡类型

export function upCardbin(data) {
  return request({
    url: '/orders/card-bin/up-cardbin',
    method: 'post',
    data: data
  });
}
// 复制订单
export function copyOrderRule(data) {
  return request({
    url: '/orders/order/copy-order-rule',
    method: 'post',
    data: data
  });
}
// 渠道卡类型列表
export function getCardChannelGroup(params) {
  return request({
    url: '/orders/card-bin/channel-group',
    method: 'get',
    params: params
  });
}
// 渠道卡类型列表
export function postCardChannelGroup(data) {
  return request({
    url: '/orders/card-bin/channel-group',
    method: 'post',
    data: data
  });
}
// 删除制卡管理
export function delCardMake(params) {
  return request({
    url: '/orders/card-make/del',
    method: 'get',
    params: params
  });
}

// 删除提成
export function deleteCommission(params) {
  return request({
    url: '/orders/card-bin/del',
    method: 'get',
    params: params
  });
}
// 保存组合子菜单
export function saveGroupChildMenus(data) {
  return request({
    url: '/orders/order/set-sub-rule',
    method: 'post',
    data: data
  });
}
// 获取平台配置业务类型
export function getBuinessType(params) {
  return request({
    url: '/orders/menu-order/buiness-type',
    method: 'get',
    params: params
  });
}
// 获取订单审核汇总信息
export function getOrderCountAudit(params) {
  return request({
    url: '/orders/order/count-audit',
    method: 'get',
    params: params
  });
}
// 冻结金额设置
export function setFreezeDay(data) {
  return request({
    url: '/orders/overdue-config/set-freeze-day',
    method: 'post',
    data: data
  });
}
// 获取景点门票关键字黑名单
export function getLvmamaKeyword(data) {
  return request({
    url: '/orders/card-rule-extend/get-ticket-keyword',
    method: 'post',
    data: data
  });
}
// 设置景点门票关键字黑名单
export function setLvmamaKeyword(data) {
  return request({
    url: '/orders/card-rule-extend/set-ticket-keyword',
    method: 'post',
    data: data
  });
}

/**
 * 获取订单规则记录日志列表
 * @param {*} data
 * @param {*} module
 * @returns
 */
export function getLogList(data, module) {
  var url = {
    customerWorkbench: '/orders/order/log-list',
    // 平台客服 客服中心 -- 客服工作台菜单进入
    orderDetails: '/orders/order/log-list',
    // 订单列表-订单详情-订单规则
    specialCardTypeManage: '/orders/new-card-rule-log/log-list',
    // 代理运营-代理卡类型管理-使用规则
    saleCardTypeManage: '/orders/new-card-rule-log/log-list',
    // 销售工具-卡类型管理-使用规则
    channelCardTypeManage: '/orders/new-card-rule-log/log-list',
    // 管理中心-卡类型管理-使用规则
    standardCardType: '/orders/plat-new-card-rule-log/log-list',
    // 平台配置-标准卡类型-使用规则
    channelCardType: '/orders/channel-new-card-rule-log/log-list',
    // 渠道-配置-卡类型配置-使用规则
    platformQueryManage: '/plat/order/channel-rule-log',
    // 平台客服-使用规则
    serviceCenter: '/orders/order/channel-rule-log' // 客服中心-使用规则
  }[module];
  return request({
    url: url,
    method: 'post',
    data: data
  });
}
// 开票信息详情
export function getOrderUserInvoiceList(data) {
  return request({
    url: '/orders/order/order-user-invoice-list',
    method: 'post',
    data: data
  });
}
// 在线点单品牌黑名单
export function setBlackOnlineOrder(data, entryType) {
  var url = {
    orderManage: '/orders/card-rule-extend/order-online-order-not-brands',
    manageCenter: '/orders/card-rule-extend/online-order-not-brands',
    platformConfig: '/orders/card-rule-extend/plat-online-order-not-brands',
    channelManage: '/orders/card-rule-extend/channel-online-order-not-brands'
  }[entryType];
  return request({
    url: url,
    method: 'post',
    data: data
  });
}

// 批量设置订单规则
export function batchSetCommonRule(data) {
  return request({
    url: '/orders/order/set-common-rule',
    method: 'post',
    data: data
  });
}
// 订单详情修改卡名称
export function editCardName(data) {
  return request({
    url: '/orders/order/update-card-name',
    method: 'post',
    data: data
  });
}
// 订单详情修改订单别名
export function editOrderAliasName(data) {
  return request({
    url: '/orders/order/update-order-alias-name',
    method: 'post',
    data: data
  });
}

// 管理中心-获取蛋糕到家数据
export function getCommonCakeHomeBrands(params) {
  return request({
    url: '/orders/card-rule-extend/common-cake-home-brands',
    method: 'get',
    params: params
  });
}
// 管理中心-保存蛋糕到家品牌黑名单
export function setCommonCakeHomeBrands(data) {
  return request({
    url: '/orders/card-rule-extend/set-common-cake-home-brands',
    method: 'post',
    data: data
  });
}
// 订单详情模拟核算提成时间
export function getImitateDate(data) {
  return request({
    url: '/orders/order-commission/active-card-date',
    method: 'post',
    data: data
  });
}
// 订单详情模拟核算提成
export function getImitateCommission(data) {
  return request({
    url: '/orders/order-commission/gauge-sales-commission',
    method: 'post',
    data: data
  });
}
//获取商务支持数据
export function getBusinessUser(params) {
  return request({
    url: '/package/package-programme/business-user',
    method: 'get',
    params: params
  });
}
//获取搭售子订单
export function getChildOrder(data) {
  return request({
    url: '/orders/order/get-child',
    method: 'post',
    data: data
  });
}
//获取应用场景
export function getUsageList(params) {
  return request({
    url: '/orders/order/usage-list',
    method: 'get',
    params: params
  });
}
//获取订单风控
export function getOrderRiskConfig(params) {
  return request({
    url: '/orders/order-risk-config/get-order-risk-config',
    method: 'get',
    params: params
  });
}
//获取订单消费风控预警
export function getOrderConsumeRemind(params) {
  return request({
    url: '/orders/order-consume-remind-config/get-order',
    method: 'get',
    params: params
  });
}
//订单设置风控级别
export function orderSetRiskConfig(data) {
  return request({
    url: '/orders/order-risk-config/order-set-config',
    method: 'post',
    data: data
  });
}
//订单设置风控级别
export function orderSetconsumeConfig(data) {
  return request({
    url: '/orders/order-consume-remind-config/set-order',
    method: 'post',
    data: data
  });
}
// 获取订单所属渠道下客户
export function getOrderChannelCustom(params) {
  return request({
    url: '/plat/customer/by-channel',
    method: 'get',
    params: params
  });
}
export function exportRechargeCard(data) {
  return request({
    url: '/orders/cardsale/export-recharge-card',
    method: 'post',
    data: data
  });
}
/**
 * 获取卡类型模板
 * @param {*} params
 * @returns
 */
export function getDecorationTemplate(params) {
  return request({
    url: '/orders/card-bin/get-decoration-template',
    method: 'get',
    params: params
  });
}
// 获取城市
export function getShopPid(data) {
  return request({
    url: '/orders/shop-region/get-area-by-pid',
    method: 'post',
    data: data
  });
}
// 获取礼包集采队列
export function getOfllineQueueisRuning(data) {
  return request({
    url: '/orders/order/get-oflline-queue-is-runing',
    method: 'post',
    data: data
  });
}
// 订单兑换登记编辑
export function upExchange(data) {
  return request({
    url: '/orders/offline-buy/up-exchange',
    method: 'post',
    data: data
  });
}
/**
 *获取问题分类
 * @param {*} params
 * @returns
 */
export function getCategoryLists(params) {
  return request({
    url: 'orders/work-order-user/category-lists',
    method: 'get',
    params: params
  });
}
// 创建工单
export function createWorkOrder(data) {
  return request({
    url: 'orders/work-order-user/create',
    method: 'post',
    data: data
  });
}
/**
 *工单列表-搜索条件
 * @param {*} params
 * @returns
 */
export function getSearchData(params) {
  return request({
    url: '/orders/work-order-user/get-search-data',
    method: 'get',
    params: params
  });
}
/**
 *工单列表-查询
 * @param {*} params
 * @returns
 */
export function getWorkOrderList(params) {
  return request({
    url: '/orders/work-order-user/lists',
    method: 'get',
    params: params
  });
}
// 跟进工单
export function addFollow(data) {
  return request({
    url: '/orders/work-order-user/add-follow',
    method: 'post',
    data: data
  });
}

/**
 *工单详情
 * @param {*} params
 * @returns
 */
export function getWorkOrderDetail(params) {
  return request({
    url: '/orders/work-order-user/detail',
    method: 'get',
    params: params
  });
}
/**
 *关闭工单
 * @param {*} params
 * @returns
 */
export function closeWorkOrder(data) {
  return request({
    url: '/orders/work-order-user/close',
    method: 'post',
    data: data
  });
}
/**
 *删除工单
 * @param {*} params
 * @returns
 */
export function deleteWorkOrder(data) {
  return request({
    url: '/orders/work-order-user/delete',
    method: 'post',
    data: data
  });
}

// 获取电影关键字黑名单
export function getMovieKeyword(data) {
  return request({
    url: '/orders/card-rule-extend/get-movie-black-keyword',
    method: 'post',
    data: data
  });
}

// 设置电影关键字黑名单
export function setMovieKeyword(data) {
  return request({
    url: '/orders/card-rule-extend/set-movie-black-keyword',
    method: 'post',
    data: data
  });
}
// 查看汇总加密
export function getCountInfoList(data) {
  return request({
    url: '/orders/order/get-count-list',
    method: 'post',
    data: data
  });
}
export function getCustomerName(params) {
  return request({
    url: '/count/order/get-customer-name',
    method: 'get',
    params: params
  });
}
// 查看商机加密
export function getOpportunityName(params) {
  return request({
    url: '/orders/order/get-opportunity-name',
    method: 'get',
    params: params
  });
}

// 获取短信发送列表
export function getSmsSendList(data) {
  return request({
    url: '/orders/order/order-sms-log',
    method: 'post',
    data: data
  });
}
// 制卡管理 添加卡类型
export function getconfigCardType(data) {
  return request({
    url: '/orders/order-config/card-type',
    method: 'post',
    data: data
  });
}
// 制卡管理 添加卡类型
export function getOfflineNum(data) {
  return request({
    url: '/orders/order/get-oflline-num',
    method: 'post',
    data: data
  });
}
// 获取商城模块应用数量
export function getOrderMenuCount(data) {
  return request({
    url: '/orders/menu-order/count',
    method: 'post',
    data: data
  });
}
// 获取商城模块应用数量
export function getMovieZydBrands(data) {
  return request({
    url: 'orders/card-rule-extend/online-zy-brinds',
    method: 'post',
    data: data
  });
}
// 通过手机号查订单
export function getOrder(data) {
  return request({
    url: '/orders/work-order-user/search-order',
    method: 'post',
    data: data
  });
}
// 创建工单
export function previewOrder(data) {
  return request({
    url: '/orders/work-order-user/preview-create',
    method: 'post',
    data: data
  });
}
// 保存充值
export function addUnfixedRecharge(data) {
  return request({
    url: '/orders/order-recharge/add-unfixed-recharge',
    method: 'post',
    data: data
  });
}
// 获取电影白名单配置类型
export function getMovieRuleType(params) {
  return request({
    url: '/orders/card-rule-extend/movie-rule-type',
    method: 'get',
    params: params
  });
}
// 取消设置电影白名单
export function delWhiteMovieList(data) {
  return request({
    url: '/orders/card-rule-extend/del-movie-white-list-type',
    method: 'post',
    data: data
  });
}
// 验证订单搭售规则是否符合
export function editOrderUserPerson(data) {
  return request({
    url: '/orders/order/up-order-user-id',
    method: 'post',
    data: data
  });
}
// 获取订单配置
export function getOrderSignConfig(data) {
  return request({
    url: '/orders/order/get-order-sign-config',
    method: 'post',
    data: data
  });
}
// 验证订单搭售规则是否符合
export function setOrderSignConfig(data) {
  return request({
    url: '/orders/order/set-order-sign-config',
    method: 'post',
    data: data
  });
}

// 设置电影自由兑黑名单
export function setMovieZydBrands(data, entryType) {
  return request({
    url: entryType === 'cardType' ? '/orders/card-rule-extend/set-common-online-zy-not-brinds' : '/orders/card-rule-extend/set-online-zy-not-brinds',
    method: 'post',
    data: data
  });
}
// 获取小规模纳税人配置
export function getTaxpayerConfig(params) {
  return request({
    url: '/user/channel-small-scale-taxpayer/get-config',
    method: 'get',
    params: params
  });
}
// 设置小规模纳税人配置
export function setTaxpayerConfig(data) {
  return request({
    url: '/user/channel-small-scale-taxpayer/set-config',
    method: 'post',
    data: data
  });
}
// 按选择项导出订单
export function exportOrderByChecked(data) {
  return request({
    url: '/orders/order/export-by-checked',
    method: 'post',
    data: data,
    timeout: 3 * 60 * 1000
  });
}

// 获取售卡数量
export function getCardSaleCount(data) {
  return request({
    url: '/orders/order/count-card-sale',
    method: 'post',
    data: data
  });
}
// /佣金激励
export function setSubjectType(data) {
  return request({
    url: '/orders/order/set-subject-type',
    method: 'post',
    data: data
  });
}
// 待认领回款列表
export function getPendingClaimMoney(data) {
  return request({
    url: '/user/bank-list/index',
    method: 'post',
    data: data
  });
}
// 待认领回款列表 - 处理
export function processedOrder(data) {
  return request({
    url: '/user/bank-list/up-status',
    method: 'post',
    data: data
  });
}
// 待认领回款列表 - 上传文件
export function importBankList(data) {
  return request({
    url: '/user/bank-list/import',
    method: 'post',
    data: data
  });
}
// 获取小规模纳税人配置
export function getPlatCustomerList(params) {
  return request({
    url: '/plat/channel/customer-list',
    method: 'get',
    params: params
  });
}
// 修改卡类型 获取渠道
export function getPlatAllChannelList(params) {
  return request({
    url: '/plat/channel/get-all-channel',
    method: 'get',
    params: params
  });
}
// 回款超期订单 跟进
export function overdueFollow(data) {
  return request({
    url: '/orders/order/overdue-follow',
    method: 'post',
    data: data
  });
}

// 创建订单 获取关联联系人
export function getContactByCustomerId(data) {
  return request({
    url: '/orders/order/get-contact-by-customer-id',
    method: 'post',
    timeout: 3 * 60 * 1000,
    data: data
  });
}
// 订单详情修改关联联系人
export function editOrderContact(data) {
  return request({
    url: '/orders/order/up-order-contact',
    method: 'post',
    data: data
  });
}
// 售卡驳回与发放
export function rejectRefundCard(data) {
  return request({
    url: '/orders/cardsale/reject-card-sale',
    method: 'post',
    data: data
  });
}
// 发送短信
export function sendConatctVerifySms(data) {
  return request({
    url: '/orders/send-sms/send-contact-verify',
    method: 'post',
    data: data
  });
}
// 校验短信验证码
export function verifyConatctSms(data) {
  return request({
    url: '/orders/send-sms/verify-contact-code',
    method: 'post',
    data: data
  });
}
// 更新认领状态
export function batchUpStatus(data) {
  return request({
    url: '/user/bank-list/batch-up-status',
    method: 'post',
    data: data
  });
}
// 优享 子订单售卡退回主订单
export function returnMainOrder(data) {
  return request({
    url: '/orders/order/choose-again',
    method: 'post',
    data: data
  });
}
// 售卡审核  激活时保存信息
export function saveAuditInfo(data) {
  return request({
    url: '/orders/order/save-audit-info',
    method: 'post',
    data: data
  });
}
// 获取发票抬头列表
export function getInvoiceAccountList(data) {
  return request({
    url: '/orders/customer-invoice-account/list',
    method: 'post',
    data: data
  });
}
// 获取卡类型列表
export function getSaleToolsCardTypeList(params) {
  return request({
    url: '/user/sales-tools/card-bin-list',
    method: 'get',
    params: params
  });
}
// 特殊金额列表
export function exportSpecialOrder(data) {
  return request({
    url: '/orders/special-order/export-list',
    method: 'post',
    data: data
  });
}
// 管理中心复制卡类型
export function copyCardType(data) {
  return request({
    url: '/orders/card-bin/copy-card-bin',
    method: 'post',
    data: data
  });
}
// 管理中心回款超期打折列表
export function getPayCycleList(data) {
  return request({
    url: '/orders/payment-cycle-config/list',
    method: 'post',
    data: data,
    timeout: 3 * 60 * 1000
  });
}
// 管理中心添加回款超期打折
export function addPayCycle(data) {
  return request({
    url: '/orders/payment-cycle-config/add',
    method: 'post',
    data: data,
    timeout: 3 * 60 * 1000
  });
}
// 管理中心添加回款超期打折
export function upPayCycle(data) {
  return request({
    url: '/orders/payment-cycle-config/up',
    method: 'post',
    data: data,
    timeout: 3 * 60 * 1000
  });
}
// 管理中心删除回款超期打折
export function delPayCycle(data) {
  return request({
    url: '/orders/payment-cycle-config/del',
    method: 'post',
    data: data,
    timeout: 3 * 60 * 1000
  });
}

// 代理回款超期打折列表
export function getAgentPayCycleList(data) {
  return request({
    url: '/orders/agent-payment-cycle-config/list',
    // url: '/orders/agent-overdue-config/list',
    method: 'post',
    data: data,
    timeout: 3 * 60 * 1000
  });
}
// 代理添加回款超期打折
export function addAgentPayCycle(data) {
  return request({
    url: '/orders/agent-payment-cycle-config/add',
    method: 'post',
    data: data,
    timeout: 3 * 60 * 1000
  });
}
// 代理添加回款超期打折
export function upAgentPayCycle(data) {
  return request({
    url: '/orders/agent-payment-cycle-config/up',
    method: 'post',
    data: data,
    timeout: 3 * 60 * 1000
  });
}
// 代理删除回款超期打折
export function delAgentPayCycle(data) {
  return request({
    url: '/orders/agent-payment-cycle-config/del',
    method: 'post',
    data: data,
    timeout: 3 * 60 * 1000
  });
}

// 平台回款超期打折列表
export function getPlatPayCycleList(data) {
  return request({
    url: '/orders/plat-payment-cycle-config/list',
    method: 'post',
    data: data,
    timeout: 3 * 60 * 1000
  });
}
// 平台添加回款超期打折
export function addPlatPayCycle(data) {
  return request({
    url: '/orders/plat-payment-cycle-config/add',
    method: 'post',
    data: data,
    timeout: 3 * 60 * 1000
  });
}
// 平台添加回款超期打折
export function upPlatPayCycle(data) {
  return request({
    url: '/orders/plat-payment-cycle-config/up',
    method: 'post',
    data: data,
    timeout: 3 * 60 * 1000
  });
}
// 平台删除回款超期打折
export function delPlatPayCycle(data) {
  return request({
    url: '/orders/plat-payment-cycle-config/del',
    method: 'post',
    data: data,
    timeout: 3 * 60 * 1000
  });
}
// 渠道回款超期打折列表
export function getChannelPayCycleList(data) {
  return request({
    url: '/orders/channel-payment-cycle-config/list',
    method: 'post',
    data: data,
    timeout: 3 * 60 * 1000
  });
}
// 渠道添加回款超期打折
export function addChannelPayCycle(data) {
  return request({
    url: '/orders/channel-payment-cycle-config/add',
    method: 'post',
    data: data,
    timeout: 3 * 60 * 1000
  });
}
// 渠道添加回款超期打折
export function upChannelPayCycle(data) {
  return request({
    url: '/orders/channel-payment-cycle-config/up',
    method: 'post',
    data: data,
    timeout: 3 * 60 * 1000
  });
}
// 渠道删除回款超期打折
export function delChannelPayCycle(data) {
  return request({
    url: '/orders/channel-payment-cycle-config/del',
    method: 'post',
    data: data,
    timeout: 3 * 60 * 1000
  });
}
//回款超期订单-支持导入跟进信息
export function importOrderFollow(data) {
  return request({
    url: '/orders/order/import-order-follow',
    method: 'post',
    timeout: 3 * 60 * 1000,
    data: data
  });
}
//管理者佣金冻结
export function getLeaderFreezeRate(data) {
  return request({
    url: '/orders/leader-freeze-rate/list',
    method: 'post',
    data: data
  });
}
//编辑管理者佣金冻结
export function upLeaderFreezeRate(data) {
  return request({
    url: '/orders/leader-freeze-rate/up',
    method: 'post',
    data: data
  });
}
//平台配置管理者佣金冻结
export function getPlatLeaderFreezeRate(data) {
  return request({
    url: '/orders/plat-leader-freeze-rate/list',
    method: 'post',
    data: data
  });
}
//平台配置编辑管理者佣金冻结
export function upPlatLeaderFreezeRate(data) {
  return request({
    url: '/orders/plat-leader-freeze-rate/up',
    method: 'post',
    data: data
  });
}
//渠道配置管理者佣金冻结
export function getChannelLeaderFreezeRate(data) {
  return request({
    url: '/orders/channel-leader-freeze-rate/list',
    method: 'post',
    data: data
  });
}
//渠道配置编辑管理者佣金冻结
export function upChannelLeaderFreezeRate(data) {
  return request({
    url: '/orders/channel-leader-freeze-rate/up',
    method: 'post',
    data: data
  });
}
//售卡列表
export function getOrdersCardSaleIndex(data) {
  return request({
    url: '/orders/cardsale/index',
    method: 'post',
    timeout: 3 * 60 * 1000,
    data: data
  });
}
export function getRealName(data) {
  return request({
    url: '/orders/order/get-real-field-value',
    method: 'post',
    data: data
  });
}
// 查看企业名称
export function getCustomerCompanyName(params) {
  return request({
    url: '/orders/customer/get-company-name',
    method: 'get',
    params: params
  });
}
// 特殊金额查看日志
export function getGeneraLogList(data) {
  return request({
    url: '/orders/general-log/list',
    method: 'post',
    data: data
  });
}
// 批量修改有效期 下载
export function downloadBatchOrderDateTemplate(data) {
  return request({
    url: '/orders/template/download',
    method: 'post',
    data: data
  });
}
// 传文件批量修改有效期
export function upBatchOrderDate(data) {
  return request({
    url: '/orders/card-operate/up-modify-expiry-date-file',
    method: 'post',
    data: data
  });
}
// 传文件批量修改有效期
export function upBatchOrderDateFile(data) {
  return request({
    url: '/orders/card-operate/batch-modify-expiry-date',
    method: 'post',
    data: data
  });
}
export function getBatchOrderDateLog(params) {
  return request({
    url: '/orders/general-log/index',
    method: 'get',
    params: params
  });
}
/**
 * 售卡管理 - 发票管理 - 作废发票
 * @param {*} data
 * @returns
 */
export function delInvoice(data) {
  return request({
    url: '/invoice/invoice/del',
    method: 'post',
    data: data
  });
}

//获取测试卡售卡设置
export function getTestCardsNumber(params) {
  return request({
    url: '/orders/test-cards/number',
    method: 'get',
    params: params
  });
}

//设置测试卡售卡设置
export function setTestCardsNumber(data) {
  return request({
    url: '/orders/test-cards/number',
    method: 'post',
    data: data
  });
}
//设置测试卡售卡设置
export function createSpecialOrder(data) {
  return request({
    url: '/orders/special-order-commission/create',
    method: 'post',
    data: data
  });
}
//设置联合跟进
export function setOrderPartner(data) {
  return request({
    url: '/orders/order/set-order-partner',
    method: 'post',
    data: data
  });
}
//获取联合跟进
export function getOrderPartnerList(data) {
  return request({
    url: '/orders/order/order-partner-list',
    method: 'post',
    data: data
  });
}
//添加联合跟进
export function addOrderPartner(data) {
  return request({
    url: '/orders/order/add-order-partner',
    method: 'post',
    data: data
  });
}
//删除联合跟进
export function delOrderPartner(data) {
  return request({
    url: '/orders/order/del-order-partner',
    method: 'post',
    data: data
  });
}
//编辑联合跟进
export function upOrderPartner(data) {
  return request({
    url: '/orders/order/up-order-partner',
    method: 'post',
    data: data
  });
}
//开启电子签名
export function signOpen(data) {
  return request({
    url: '/orders/cardsale/sign-open',
    method: 'post',
    data: data
  });
}
// 中影推送订单
export function zhongYingPushOrder(data) {
  return request({
    url: '/orders/order/zhong-ying-push-order',
    method: 'post',
    data: data
  });
}

// 中影确认订单
export function zhongYingConfirmOrder(data) {
  return request({
    url: '/orders/order/zhong-ying-confirm-order',
    method: 'post',
    data: data
  });
}
// 获取VP审核用户列表
export function getVpUserList(params) {
  return request({
    url: '/orders/organize/vp-list',
    method: 'get',
    params: params
  });
}
// 订单驳回
export function orderNewReject(data) {
  return request({
    url: '/orders/order/new-reject',
    method: 'post',
    data: data
  });
}
// 获取三方发送模板
export function getSanFangSendTemplate(params) {
  return request({
    url: '/orders/send-sms/card-ding-talk-template',
    method: 'get',
    params: params
  });
}
// 提交三方发送模板
export function submitSanFangSendTemplate(data) {
  return request({
    url: '/orders/send-sms/card-ding-talk-send',
    method: 'post',
    data: data
  });
}
export function getSameTypeHistoryOrderList(params) {
  return request({
    url: '/count/order/audit-order-list',
    method: 'get',
    params: params
  });
}
// 查订单无【自组礼包、自选商城、未添加功能菜单】则VP审核时，不展示【非常规礼包】
export function isNeedOptionalMallCommision(data) {
  return request({
    url: '/orders/order/is-need-optional-mall-commision',
    method: 'post',
    data: data
  });
}
//
export function getOrderSofflineList(data) {
  return request({
    url: '/orders/cardsale/offline-list',
    method: 'post',
    timeout: 3 * 60 * 1000,
    data: data
  });
}

// 包含第三方资源菜单时提醒修改【佣金业绩】核算方式
export function upSettlementType(data) {
  return request({
    url: '/orders/order/up-settlement-type',
    method: 'post',
    data: data
  });
}
// 获取订单佣金明细
export function getOrderCommissionList(data) {
  return request({
    url: '/orders/order/order-commission-list',
    method: 'post',
    data: data
  });
}
// 获取订单佣金明细
export function getOrderExchangeInfo(data) {
  return request({
    url: '/orders/voucher-order/exchange-info',
    method: 'post',
    data: data
  });
}
// 礼包配送信息数据
export function getOrderPackageList(data) {
  return request({
    url: '/orders/voucher-order/delivery-list',
    method: 'post',
    data: data
  });
}
// 账期校验是否大于最长账期
export function checkOrderPaymentDay(data) {
  return request({
    url: '/orders/order/check-order-payment-day',
    method: 'post',
    data: data
  });
}
// 佣金核算方式
export function upOrderSettlementType(data) {
  return request({
    url: '/orders/order/order-up-settlement-type',
    method: 'post',
    data: data
  });
}
// 订单详情结算方式
export function upOrderType(data) {
  return request({
    url: '/orders/order/up-order ',
    method: 'post',
    data: data
  });
}
// 订单详情  清空余额列表 审核
export function auditClearPoint(data) {
  return request({
    url: '/orders/cardsale/audit-clear-point',
    method: 'post',
    data: data
  });
}
// 获取订单商务满意度人员
export function getOrderSatisfaction(params) {
  return request({
    url: '/package/programme-purchase-quotation/order-satisfaction',
    method: 'get',
    params: params
  });
}
// 获取订单商务满意度二维码
export function getOrderSatisfactionQrcode(params) {
  return request({
    url: '/package/programme-purchase-quotation/satisfaction-qr',
    method: 'get',
    params: params
  });
}
// 查看汇总加密 - 实际账期超期客户
export function getPaymentDaysCountInfoList(data) {
  return request({
    url: '/orders/payment-days/count-customer',
    method: 'post',
    data: data
  });
}
// 订单 批量清余额
export function upClearBalanceFile(data) {
  return request({
    url: '/orders/order/up-clear-point-file',
    method: 'post',
    data: data
  });
}
// 获取订单风险督办数据
export function getRiskControlSuperviseInfo(params) {
  return request({
    url: '/count/order/risk-control-supervise-info',
    method: 'get',
    params: params
  });
}
// 风险督办保存
export function saveRiskControlSupervise(data) {
  return request({
    url: '/count/order/save-risk-control-supervise',
    method: 'post',
    data: data
  });
}

// 商品可见性校验 - 获取实体商品列表
export function getMallCheckEntityData(params) {
  return request({
    url: 'orders/mall-check/index',
    method: 'get',
    params: params
  });
}